import { Label } from '@savvy-kit/components/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@savvy-kit/components/select';

export type FilterOperatorOption = {
  readonly value: string;
  readonly label: string;
};

export type FilterOperatorSelectProps<T extends string> = {
  readonly id: string;
  readonly label?: string;
  readonly value: T;
  readonly options: readonly FilterOperatorOption[];
  readonly onChange: (value: T) => void;
};

export function FilterOperatorSelect<T extends string>({
  id,
  label = 'Condition',
  value,
  options,
  onChange,
}: FilterOperatorSelectProps<T>) {
  if (options.length <= 1) {
    return null;
  }

  const isOptionValue = (nextValue: string): nextValue is T => options.some((op) => op.value === nextValue);

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Select
        value={value}
        items={options.map((op) => ({ value: op.value, label: op.label }))}
        onValueChange={(nextValue) => {
          if (isOptionValue(nextValue)) onChange(nextValue);
        }}
      >
        <SelectTrigger id={id} size="sm" aria-label="Filter condition">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((op) => (
            <SelectItem key={op.value} value={op.value}>
              {op.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
